export default "__VITE_ASSET__DTi0Wfex__"